import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {
    state = {
        status: this.props.status,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (status) => (event) => {
        this.props.handleClose(status);
    };

    render() {
        const { status } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'display_filtermenu_status_title' })}
                            </InputLabel>
                            <Select
                                native
                                value={status}
                                onChange={this.handleChange}
                                inputProps={{ name: 'status', id: 'status-id' }}
                            >
                                <option value={0}>
                                    {intl.formatMessage({ id: 'display_filtermenu_status_all' })}
                                </option>
                                <option value={1}>
                                    {intl.formatMessage({
                                        id: 'display_filtermenu_status_correct',
                                    })}
                                </option>
                                <option value={2}>
                                    {intl.formatMessage({
                                        id: 'display_filtermenu_status_incorrect',
                                    })}
                                </option>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.handleClose(status)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Filter = connect(
    mapStateToProps,
    null,
)(Filter);

Filter = injectIntl(Filter);

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/manage/displays/FilterMenu.js